import { render, staticRenderFns } from "./taskInfo.vue?vue&type=template&id=bd474496&scoped=true&"
import script from "./taskInfo.vue?vue&type=script&lang=js&"
export * from "./taskInfo.vue?vue&type=script&lang=js&"
import style0 from "./taskInfo.vue?vue&type=style&index=0&id=bd474496&prod&lang=less&scoped=true&"
import style1 from "./taskInfo.vue?vue&type=style&index=1&id=bd474496&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd474496",
  null
  
)

export default component.exports